import { combineReducers } from 'redux';
import authReducer from './authReducer';
import centersReducer from './centersReducer';
import jurisdictionsReducer from './jurisdictionsReducer';
import proceedingReducer from './proceedingReducer';

export default combineReducers({
    auth: authReducer,
    centers: centersReducer,
    jurisdictions: jurisdictionsReducer,
    proceeding: proceedingReducer
});